import DataDisplayRowI from "../DataDisplayRowI";
import getPCComponentParameterRow from "../DataDisplayRow/PCComponentParameterRow";
import DataDisplayTable from "../DataDisplayTable";

class PCComponentParameterTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getPCComponentParameterRow()
    }
}

let pcComponentParameterTable: PCComponentParameterTable | null = null;

export default function getPCComponentParameterTable(): PCComponentParameterTable {
    if (pcComponentParameterTable === null)
        pcComponentParameterTable = new PCComponentParameterTable()
    return pcComponentParameterTable
}